import { Switch, Route } from 'react-router-dom';

import SignInPage from 'pages/auth/SignInPage';
import InviteSignUpPage from 'pages/auth/InviteSignUpPage';
import ForgetPasswordPage from 'pages/auth/ForgetPasswordPage';

function App() {
  return (
    <Switch>
      <Route path="/signup/:invite_id">
        <InviteSignUpPage />
      </Route>

      <Route path="/forget-password">
        <ForgetPasswordPage />
      </Route>

      <Route path="*">
        <SignInPage />
      </Route>
    </Switch>
  );
}

export default App;
